/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";

// @material-ui/core components
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  ButtonBase,
  DialogContent,
  FormGroup,
  FormLabel,
  Grid,
  Typography,
  OutlinedInput,
  CircularProgress,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CardContent,
  Paper,
  FormControl,
  Select,
  MenuItem,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  LinearProgress,
} from "@material-ui/core";

import {
  ExpandMore as ExpandMoreIcon,
  KeyboardArrowDown,
} from "@material-ui/icons";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import componentStylesDialog from "assets/theme/components/dialog";
import MaskAndValid from "utils/maskAndValid";
import Api from "lib/api/httpRequestHelper";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import ImagePlaceholder from "components/Image/ImagePlaceholder";
import OrderConfirmation from "./DialogTrocaDevolucaoConfirmacaoPedido";
import useLogs from "hooks/logs";
import PeriodField from "components/_refactor/fields/period-field";
import { IsMobile } from "utils/is-mobile";

const useStyles = makeStyles({
  paper: { overflow: "hidden" },
});
const useStylesDialog = makeStyles(componentStylesDialog);

const dataHoje = new Date().toISOString().slice(0, 10);

const RadioOption = withStyles(() => ({
  label: {
    fontSize: "0.95rem",
  },
  root: {
    marginBottom: 0,
  },
}))(FormControlLabel);

const typeExchangeList = [
  {
    name: "Devolução",
    value: "DEVOLUCAO",
    id: 1,
  },
  {
    name: "Troca",
    value: "TROCA",
    id: 2,
  },
];

export default function DialogTrocaDevolucaoUsuario({
  onClose,
  type,
  idPedido,
}) {
  const classes = { ...useStyles(), ...useStylesDialog() };
  const detailsRef = useRef(null);
  const snackbar = useSnackbar();
  const history = useHistory();
  const { setLocalStorageApiProblem } = useLogs();

  const isMobile = IsMobile();

  const [expanded, setExpanded] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [searchOrders, setSearchOrders] = useState(false);
  const [searchExchanges, setSearchExchanges] = useState(false);

  const [listItemsToChange, setListItemsToChange] = useState([]);
  const [openConfirmation, setOpenConfirmation] = useState(false);

  const [cpfCnpj, setCpfCnpj] = useState("");
  const [periodo, setPeriodo] = useState(null);
  const [dataInicial, setDataInicial] = useState(dataHoje);
  const [dataFinal, setDataFinal] = useState();
  const [orderList, setOrderList] = useState([]);
  const [newOrderList, setNewOrderList] = useState([]);
  const [idTrocaDevolucao, setIdTrocaDevolucao] = useState("");
  const [listExchangeProducts, setListExchangeProducts] = useState([]);
  const [orderId, setOrderId] = useState("");
  const [storeId, setStoreId] = useState("");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleSearchOrders = async (idPedido) => {
    setSearchOrders(true);
    const verifyID = typeof idPedido === "string" ? idPedido : "";

    await Api.get(
      "attendance-b2b-list",
      "attendance",
      "?cpfConsumidor=" +
        cpfCnpj +
        "dtIni" +
        dataInicial +
        "dtFim" +
        dataFinal +
        "&nrPedido=" +
        verifyID +
        "&idLoja=TODAS&status=E",
      true
    )
      .then((value) => {
        setOrderList(value?.Result?.ListPedidos);
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "153",
          screen: "Trocas / Devoluções Prateleira Infinita",
          problem: `Erro na chamada do endpoint attendance-b2b-list - ${error}`,
        });
      })
      .finally(() => setSearchOrders(false));
  };

  const handleGetListExchanges = async (nrPedido) => {
    setSearchExchanges(true);

    await Api.get(
      "list-order-change-product",
      "trocas",
      "?idPedido=" + nrPedido,
      true
    )
      .then((res) => {
        if (res?.Result?.ListaPedidoTrocaDevolucao?.length !== 0) {
          setIdTrocaDevolucao(
            res?.Result?.ListaPedidoTrocaDevolucao[0]?.IdTrocaDevolucao
          );
          setListExchangeProducts(
            res?.Result?.ListaPedidoTrocaDevolucao[0]?.ListDevolucaoTroca
          );
        } else {
          setListExchangeProducts([]);
        }
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "153",
          screen: "Trocas / Devoluções Prateleira Infinita",
          problem: `Erro na chamada do endpoint list-order-change-product - ${error}`,
        });
      })
      .finally(() => {
        setSearchExchanges(false);
      });
  };

  const onSubmit = async () => {
    const listExchanges = [];
    let newObject = {};
    setSubmitting(true);

    if (idTrocaDevolucao === "") {
      listItemsToChange?.map((item) => {
        if (item?.Motivo && item?.QuantidadeSolicitada) {
          newObject = {
            idProduto: item?.IdProduto,
            motivo: item?.Motivo,
            quantidadeTroca: item?.QuantidadeSolicitada,
            tipoSolicitacao: item?.TipoSolicitacao,
            observacao: item?.Observacao,
            idPedido: orderId,
          };
          listExchanges.push(newObject);
        }
      });
    } else {
      listItemsToChange?.map((item) => {
        if (item?.Motivo && item?.QuantidadeSolicitada) {
          newObject = {
            idTrocaDevolucaoItem: 0,
            idProduto: item?.IdProduto,
            motivo: item?.Motivo,
            quantidadeTroca: item?.QuantidadeSolicitada,
            tipoSolicitacao: item?.TipoSolicitacao,
            observacao: item?.Observacao,
            idPedido: orderId,
          };
          listExchanges.push(newObject);
        }
      });
    }

    idTrocaDevolucao === ""
      ? await Api.post(
          "create-order-change-product",
          "trocas",
          {
            idPessoaLoja: storeId,
            idPedido: orderId,
            itens: listExchanges,
          },
          true
        )
          .then((res) => {
            if (res?.Success) {
              snackbar.showMessage("Solicitação realizada com sucesso!", {
                severity: "success",
              });
              onClose(orderId);
              return history.push(
                `/admin/trocas-devolucoes-prateleira-infinita`
              );
            }
          })
          .catch((error) => {
            console.log(error);
            snackbar.showMessage(error, {
              severity: "error",
            });
            setLocalStorageApiProblem({
              idMenuAccess: "153",
              screen: "Trocas / Devoluções Prateleira Infinita",
              problem: `Erro na chamada do endpoint create-order-change-product - ${error}`,
            });
          })
          .finally(() => setSubmitting(false))
      : await Api.put(
          "edit-order-change-product",
          "trocas",
          {
            idTrocaDevolucao: idTrocaDevolucao,
            itens: listExchanges,
          },
          true
        )
          .then((res) => {
            if (res?.Success) {
              snackbar.showMessage("Solicitação realizada com sucesso!", {
                severity: "success",
              });
              onClose(orderId);
              return history.push(
                `/admin/trocas-devolucoes-prateleira-infinita`
              );
            }
          })
          .catch((error) => {
            console.log(error);
            snackbar.showMessage(error, {
              severity: "error",
            });
            setLocalStorageApiProblem({
              idMenuAccess: "153",
              screen: "Trocas / Devoluções Prateleira Infinita",
              problem: `Erro na chamada do endpoint edit-order-change-product - ${error}`,
            });
          })
          .finally(() => setSubmitting(false));
  };

  const verifyRequiredProps = () => {
    const listItensToChange = [];
    let requiredProps = false;

    newOrderList?.forEach((order) => {
      if (order?.IdPedidoEcommerce === orderId) {
        order?.Itens?.forEach((item) => {
          if (
            (item?.Motivo !== "" && item?.QuantidadeSolicitada === "") ||
            (item?.Motivo !== "" && item?.QuantidadeSolicitada === 0) ||
            (item?.Motivo === "" && item?.QuantidadeSolicitada !== "")
          ) {
            requiredProps = true;
            return snackbar.showMessage(
              "Verifique as informaçõs enviadas. Os campos motivo e quantidade são obrigatórios.",
              {
                severity: "error",
              }
            );
          }
        });
        order?.Itens?.map((item) => {
          if (
            item?.Motivo !== "" &&
            (item?.QuantidadeSolicitada !== "" ||
              item?.QuantidadeSolicitada !== 0) &&
            !requiredProps
          ) {
            const compareItens = listItensToChange.find(
              (change) => item?.IdProduto === change?.IdProduto
            );
            if (compareItens === undefined) {
              listItensToChange?.push(item);
            }
          }
        });
      }
    });

    if (listItensToChange?.length !== 0) {
      setListItemsToChange(listItensToChange);
      setOpenConfirmation(true);
    }
  };

  useEffect(() => {
    if (idTrocaDevolucao === "" && listExchangeProducts?.length === 0) {
      const newOrdersList = orderList?.map((order) => {
        const listItems = order?.Itens.map((item) => {
          return {
            ...item,
            Ativo: item?.Ativo,
            DescricaoProduto: item?.DescricaoProduto,
            Foto: item?.Foto,
            IdAtendimentoApp: item?.IdAtendimentoApp,
            IdAtendimentoAppItem: item?.IdAtendimentoAppItem,
            IdProduto: item?.IdProduto,
            QuantidadeOriginal: item?.Quantidade,
            QuantidadeTrocaDev: null,
            QuantidadeRestante: null,
            QuantidadeSolicitada: "",
            Motivo: "",
            TipoSolicitacao: "DEVOLUCAO",
            Observacao: "",
            IdTrocaDevolucaoItem: null,
          };
        });

        return {
          ...order,
          Itens: listItems,
        };
      });
      const listOrders = [];
      newOrdersList?.map((order) => {
        if (order?.Status === "Enviado") {
          listOrders?.push(order);
        }
      });
      setNewOrderList(listOrders);
    }

    if (listExchangeProducts?.length !== 0) {
      const newOrdersList = orderList.map((order) => {
        const listItems = order?.Itens?.map((item) => {
          const compareItens = listExchangeProducts.find(
            (change) => item?.IdProduto === change?.IdProduto
          );

          if (compareItens) {
            return {
              ...item,
              TipoSolicitacao: compareItens?.TipoSolicitacao,
              IdTrocaDevolucaoItem: compareItens?.IdTrocaDevolucaoItem,
              QuantidadeTrocaDev: compareItens?.QuantidadeTroca,
              QuantidadeRestante: compareItens?.QuantidadeRestante,
              QuantidadeSolicitada: "",
              Motivo: "",
              Observacao: "",
              QuantidadeOriginal: item?.Quantidade,
            };
          } else {
            return {
              ...item,
              TipoSolicitacao: "DEVOLUCAO",
              IdTrocaDevolucaoItem: null,
              QuantidadeTrocaDev: null,
              QuantidadeRestante: null,
              QuantidadeSolicitada: "",
              Motivo: "",
              Observacao: "",
              QuantidadeOriginal: item?.Quantidade,
            };
          }
        });

        return {
          ...order,
          Itens: listItems,
        };
      });
      const listOrders = [];
      newOrdersList?.map((order) => {
        if (order?.Status === "Enviado") {
          listOrders?.push(order);
        }
      });
      setNewOrderList(listOrders);
    }
  }, [idTrocaDevolucao, listExchangeProducts, orderList]);

  useEffect(() => {
    if (orderList?.length === 0 && cpfCnpj !== "") {
      snackbar.showMessage(
        "Não foram localizados pedido para o CPF/CNPJ informado.",
        {
          severity: "success",
        }
      );
    }
  }, [orderList]);

  useEffect(() => {
    if (idPedido && type === "addItem") {
      handleSearchOrders(idPedido);
      handleGetListExchanges(idPedido);
    }
  }, [idPedido]);

  return (
    <Dialog
      open
      onClose={() => onClose(null)}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      classes={{ paper: classes.paper }}
      maxWidth="lg"
    >
      <div className={classes.dialogHeader}>
        <Typography variant="h5" component="h5" className={classes.dialogTitle}>
          {type === "addItem"
            ? "Adicionar itens à Troca / Devolução"
            : "Solicitação de Troca / Devolução"}
        </Typography>
      </div>

      <DialogContent
        ref={detailsRef}
        style={{
          paddingRight: "20px",
          marginRight: "1.5rem",
          overflowX: "hidden",
          minHeight: "450px",
        }}
      >
        <Grid
          container
          style={{ marginBottom: "1rem" }}
          hidden={type === "addItem"}
        >
          <Grid item xs={isMobile ? 12 : 4}>
            <FormGroup>
              <FormLabel>CPF/CNPJ CONSUMIDOR</FormLabel>
              <OutlinedInput
                fullWidth
                disabled={submitting || searchOrders || searchExchanges}
                type="text"
                value={
                  cpfCnpj?.length <= 13
                    ? MaskAndValid.maskCPF(cpfCnpj)
                    : cpfCnpj?.length > 14
                    ? MaskAndValid.maskCNPJ(cpfCnpj)
                    : cpfCnpj
                }
                onChange={(e) => {
                  setCpfCnpj(e.target.value);
                }}
                onInput={(e) => {
                  e.target.value = e.target.value.toString().slice(0, 18);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearchOrders();
                  }
                }}
              />
            </FormGroup>
          </Grid>
          <PeriodField
            label="Período"
            value={periodo}
            onChange={setPeriodo}
            disabled={searchOrders || submitting}
            required={false}
            initialDate={dataInicial}
            finalDate={dataFinal}
            setInitialDate={setDataInicial}
            setFinalDate={setDataFinal}
            padding={false}
          />
          <Grid
            item
            xs={isMobile ? 12 : 4}
            style={{
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
            }}
          >
            <Button
              style={{ marginLeft: isMobile ? 0 : "1rem" }}
              component={Box}
              onClick={handleSearchOrders}
              color="default"
              variant="contained"
              disabled={submitting || searchOrders || !cpfCnpj}
            >
              {searchOrders ? "Buscando pedidos..." : "Buscar pedidos"}
              {searchOrders ? (
                <CircularProgress style={{ marginLeft: 5 }} size={16} />
              ) : null}
            </Button>
          </Grid>
        </Grid>
        <Grid
          container
          hidden={
            orderList?.length === 0 ||
            newOrderList?.length === 0 ||
            searchOrders
          }
        >
          <Grid item xs={12}>
            {newOrderList?.map((order) => (
              <Accordion
                key={order?.IdPedidoEcommerce}
                expanded={
                  (type === "addItem" && orderList?.length !== 0) ||
                  expanded === order?.IdPedidoEcommerce
                }
                onChange={handleChange(order?.IdPedidoEcommerce)}
              >
                <AccordionSummary
                  disabled={searchExchanges}
                  expandIcon={
                    searchExchanges && orderId === order?.IdPedidoEcommerce ? (
                      <CircularProgress style={{ marginLeft: 5 }} size={16} />
                    ) : (
                      <ExpandMoreIcon />
                    )
                  }
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  onClick={() => {
                    setOrderId(order?.IdPedidoEcommerce);
                    setStoreId(order?.IdPessoaLoja);
                    if (expanded !== order?.IdPedidoEcommerce) {
                      handleGetListExchanges(order?.IdPedidoEcommerce);
                    }
                  }}
                >
                  <Typography
                    className={classes.heading}
                  >{`Pedido ${order?.IdPedidoEcommerce}`}</Typography>
                </AccordionSummary>
                <AccordionDetails
                  style={{ padding: 0 }}
                  hidden={searchExchanges}
                >
                  <CardContent>
                    <Grid container>
                      <Grid item xs={12}>
                        {order?.Itens?.map((itemAtendimento, index) => {
                          return (
                            <Paper key={index} className={classes.paper}>
                              <Grid container spacing={1}>
                                <Grid item>
                                  <ButtonBase className={classes.image}>
                                    <ImagePlaceholder
                                      className={classes.img}
                                      alt="Imagem do item do atendimento"
                                      src={itemAtendimento.Foto}
                                      width={75}
                                      widthOnError={40}
                                      imagePreviewTitle={`Item ${itemAtendimento.IdProduto}`}
                                    />
                                  </ButtonBase>
                                </Grid>
                                <Grid
                                  item
                                  xs={isMobile ? 12 : 6}
                                  sm
                                  container
                                  style={{ margin: "0.5rem 0" }}
                                >
                                  <Grid
                                    item
                                    xs={isMobile ? 12 : "auto"}
                                    container
                                    spacing={1}
                                    display="flex"
                                  >
                                    <Grid item xs={isMobile ? 12 : 6}>
                                      <Typography
                                        gutterBottom
                                        variant="subtitle2"
                                        style={{ fontSize: "13px" }}
                                      >
                                        {itemAtendimento.DescricaoProduto}
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        color="textSecondary"
                                        style={{ fontSize: "13px" }}
                                      >
                                        Código do Produto :{" "}
                                        {itemAtendimento.IdProduto}
                                      </Typography>
                                      <Typography
                                        variant="subtitle2"
                                        style={{ fontSize: "13px" }}
                                      >
                                        Quantidade Original :{" "}
                                        {itemAtendimento?.QuantidadeOriginal}
                                      </Typography>
                                      <>
                                        {itemAtendimento?.QuantidadeRestante !==
                                          null && (
                                          <Typography
                                            variant="subtitle2"
                                            style={{ fontSize: "13px" }}
                                          >
                                            Quantidade Restante :{" "}
                                            {itemAtendimento.QuantidadeRestante}
                                          </Typography>
                                        )}
                                      </>
                                    </Grid>

                                    <Grid
                                      item
                                      xs={isMobile ? 12 : 6}
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <Grid container>
                                        <Grid
                                          item
                                          xs={isMobile ? 12 : 6}
                                          style={{
                                            marginBottom: isMobile ? "1rem" : 0,
                                          }}
                                        >
                                          <FormGroup>
                                            <FormLabel
                                              style={{ fontSize: "12px" }}
                                            >
                                              MOTIVO
                                            </FormLabel>
                                            <FormControl
                                              variant="outlined"
                                              fullWidth
                                              disabled={
                                                submitting ||
                                                itemAtendimento.QuantidadeRestante ===
                                                  0
                                              }
                                              style={{ height: "0.5rem" }}
                                            >
                                              <Select
                                                style={{ height: "2rem" }}
                                                name="motivo"
                                                value={
                                                  itemAtendimento.QuantidadeRestante ===
                                                  0
                                                    ? ""
                                                    : itemAtendimento?.Motivo
                                                }
                                                onChange={(e) => {
                                                  setOrderId(
                                                    order?.IdPedidoEcommerce
                                                  );
                                                  setNewOrderList(
                                                    newOrderList.map(
                                                      (order) => {
                                                        const listItems =
                                                          order?.Itens?.map(
                                                            (item) => {
                                                              if (
                                                                item?.IdProduto ===
                                                                itemAtendimento?.IdProduto
                                                              ) {
                                                                if (
                                                                  e.target
                                                                    .value !==
                                                                  ""
                                                                ) {
                                                                  return {
                                                                    ...item,
                                                                    Motivo:
                                                                      e.target
                                                                        .value,
                                                                  };
                                                                } else {
                                                                  return {
                                                                    ...item,
                                                                    Motivo: "",
                                                                  };
                                                                }
                                                              } else {
                                                                return item;
                                                              }
                                                            }
                                                          );
                                                        return {
                                                          ...order,
                                                          Itens: listItems,
                                                        };
                                                      }
                                                    )
                                                  );
                                                }}
                                                IconComponent={
                                                  KeyboardArrowDown
                                                }
                                              >
                                                <MenuItem value={""}>
                                                  Selecione...
                                                </MenuItem>
                                                <MenuItem
                                                  value={"ARREPENDIMENTO"}
                                                >
                                                  Arrependimento/Desistência
                                                </MenuItem>
                                                <MenuItem value={"DEFEITO"}>
                                                  Produto com defeito
                                                </MenuItem>
                                                <MenuItem value={"NAOGOSTOU"}>
                                                  Não gostou
                                                </MenuItem>
                                                <MenuItem value={"OUTROS"}>
                                                  Outros
                                                </MenuItem>
                                              </Select>
                                            </FormControl>
                                          </FormGroup>
                                        </Grid>
                                        <Grid item xs={isMobile ? 12 : 6}>
                                          <FormGroup>
                                            <FormLabel
                                              style={{ fontSize: "12px" }}
                                            >
                                              QUANTIDADE
                                            </FormLabel>
                                            <TextField
                                              name="quantidade"
                                              type="number"
                                              fullWidth
                                              disabled={
                                                submitting ||
                                                itemAtendimento.QuantidadeRestante ===
                                                  0
                                              }
                                              value={
                                                itemAtendimento?.QuantidadeSolicitada
                                              }
                                              variant="outlined"
                                              inputProps={{
                                                max: itemAtendimento?.QuantidadeRestante
                                                  ? itemAtendimento?.QuantidadeRestante
                                                  : itemAtendimento?.QuantidadeOriginal,
                                                min: 0,
                                                onKeyDown: (event) => {
                                                  event.preventDefault();
                                                },
                                                style: {
                                                  height: "2rem",
                                                },
                                              }}
                                              onInput={(e) => {
                                                setOrderId(
                                                  order?.IdPedidoEcommerce
                                                );
                                                setNewOrderList(
                                                  newOrderList.map((order) => {
                                                    const listItems =
                                                      order?.Itens?.map(
                                                        (item) => {
                                                          if (
                                                            item?.IdProduto ===
                                                            itemAtendimento?.IdProduto
                                                          ) {
                                                            if (
                                                              e.target.value !==
                                                              "0"
                                                            ) {
                                                              return {
                                                                ...item,
                                                                QuantidadeSolicitada:
                                                                  parseInt(
                                                                    e.target
                                                                      .value
                                                                  ),
                                                              };
                                                            } else {
                                                              return {
                                                                ...item,
                                                                QuantidadeSolicitada:
                                                                  "",
                                                              };
                                                            }
                                                          } else {
                                                            return item;
                                                          }
                                                        }
                                                      );
                                                    return {
                                                      ...order,
                                                      Itens: listItems,
                                                    };
                                                  })
                                                );
                                              }}
                                            />
                                          </FormGroup>
                                        </Grid>
                                      </Grid>
                                      <Grid
                                        container
                                        style={{ marginBottom: "-1rem" }}
                                      >
                                        <Grid
                                          item
                                          xs={isMobile ? 12 : 6}
                                          style={{
                                            marginBottom: isMobile
                                              ? "-1.5rem"
                                              : 0,
                                          }}
                                        >
                                          <FormGroup>
                                            <FormLabel
                                              style={{ fontSize: "12px" }}
                                            >
                                              TIPO DE SOLICITAÇÃO
                                            </FormLabel>
                                            <RadioGroup
                                              aria-label="opções de solicitação"
                                              required
                                              name="tipo"
                                              value={itemAtendimento?.Tipo}
                                              disabled={
                                                submitting ||
                                                itemAtendimento.QuantidadeRestante ===
                                                  0
                                              }
                                              style={{
                                                display: "flex",
                                                flexDirection: "row",
                                              }}
                                              onChange={(e) => {
                                                setOrderId(
                                                  order?.IdPedidoEcommerce
                                                );
                                                setNewOrderList(
                                                  newOrderList.map((order) => {
                                                    const listItems =
                                                      order?.Itens?.map(
                                                        (item) => {
                                                          if (
                                                            item?.IdProduto ===
                                                            itemAtendimento?.IdProduto
                                                          ) {
                                                            return {
                                                              ...item,
                                                              TipoSolicitacao:
                                                                e.target.value,
                                                            };
                                                          } else {
                                                            return item;
                                                          }
                                                        }
                                                      );
                                                    return {
                                                      ...order,
                                                      Itens: listItems,
                                                    };
                                                  })
                                                );
                                              }}
                                            >
                                              {typeExchangeList.map((type) => {
                                                return (
                                                  <RadioOption
                                                    disabled={
                                                      submitting ||
                                                      itemAtendimento.QuantidadeRestante ===
                                                        0
                                                    }
                                                    className={
                                                      classes.smallRadioButton
                                                    }
                                                    key={type?.id}
                                                    value={type?.value}
                                                    checked={
                                                      itemAtendimento?.TipoSolicitacao ===
                                                      type?.value
                                                    }
                                                    control={
                                                      <Radio color="primary" />
                                                    }
                                                    label={type.name}
                                                  />
                                                );
                                              })}
                                            </RadioGroup>
                                          </FormGroup>
                                        </Grid>
                                        <Grid item xs={isMobile ? 12 : 6}>
                                          <FormGroup>
                                            <FormLabel
                                              style={{ fontSize: "12px" }}
                                            >
                                              OBSERVAÇÃO
                                            </FormLabel>
                                            <TextField
                                              name="observacao"
                                              fullWidth
                                              multiline
                                              rows="3"
                                              onChange={(e) => {
                                                setNewOrderList(
                                                  newOrderList.map((order) => {
                                                    const listItems =
                                                      order?.Itens?.map(
                                                        (item) => {
                                                          if (
                                                            item?.IdProduto ===
                                                            itemAtendimento?.IdProduto
                                                          ) {
                                                            if (
                                                              e.target.value !==
                                                              ""
                                                            ) {
                                                              return {
                                                                ...item,
                                                                Observacao:
                                                                  e.target
                                                                    .value,
                                                              };
                                                            } else {
                                                              return {
                                                                ...item,
                                                                Observacao: "",
                                                              };
                                                            }
                                                          } else {
                                                            return item;
                                                          }
                                                        }
                                                      );
                                                    return {
                                                      ...order,
                                                      Itens: listItems,
                                                    };
                                                  })
                                                );
                                              }}
                                              disabled={
                                                submitting ||
                                                itemAtendimento.QuantidadeRestante ===
                                                  0
                                              }
                                              value={
                                                itemAtendimento.QuantidadeRestante ===
                                                0
                                                  ? ""
                                                  : itemAtendimento?.Observacao
                                              }
                                              variant="outlined"
                                              inputProps={{ min: 0 }}
                                            />
                                          </FormGroup>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Paper>
                          );
                        })}
                      </Grid>
                      <Button
                        component={Box}
                        onClick={() => verifyRequiredProps()}
                        color="default"
                        variant="contained"
                        disabled={submitting || searchOrders}
                        style={{ margin: "0.5rem 1rem 0 auto" }}
                      >
                        {submitting ? "Enviando solicitação..." : "Solicitar"}
                        {submitting ? (
                          <CircularProgress
                            style={{ marginLeft: 5 }}
                            size={16}
                          />
                        ) : null}
                      </Button>
                    </Grid>
                  </CardContent>
                </AccordionDetails>
              </Accordion>
            ))}
            <>
              {openConfirmation && (
                <OrderConfirmation
                  itens={listItemsToChange}
                  onClose={({ confirmation }) => {
                    if (confirmation) {
                      setOpenConfirmation(false);
                      onSubmit();
                    } else {
                      setOpenConfirmation(false);
                      setListItemsToChange([]);
                    }
                  }}
                />
              )}
            </>
          </Grid>
        </Grid>
        {type === "addItem" && searchOrders && (
          <div>
            <span>{"Buscando produtos..."}</span>
            <LinearProgress />
          </div>
        )}
      </DialogContent>

      <DialogActions>
        <Button
          component={Box}
          onClick={() => onClose(null)}
          disabled={submitting || searchOrders}
        >
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
